// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/chartstatuscard/index.scss
// module id = 2708
// module chunks = 13